"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _store = require("../../redux/store");
var _reactI18next = require("react-i18next");
var _SubscriptionIcon = _interopRequireDefault(require("../SubscriptionIcon"));
var _Price = _interopRequireDefault(require("../Price"));
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _planHelper = require("../../util/planHelper");
var _isPriceTemporaryModified = _interopRequireDefault(require("../../util/isPriceTemporaryModified"));
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _OfferSwitchCardStyled = require("./OfferSwitchCardStyled");
var _jsxRuntime = require("react/jsx-runtime");
var BlockedIcon = function BlockedIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("style", {
        children: [".c", "{", "fill:#f8fafd", "}"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-421 -539)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        width: "18",
        height: "18",
        rx: "3",
        transform: "translate(421 539)",
        style: {
          fill: "#d3dbe6"
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M7.717-13.6a.777.777 0 0 1-.781.773H1.708a.77.77 0 0 1-.781-.787l-.45-4.665a.763.763 0 0 1 .78-.762h6.13a.759.759 0 0 1 .781.736Zm-5.306-7.818a1.87 1.87 0 0 1 1.912-1.77 1.87 1.87 0 0 1 1.912 1.77v1.894H2.411Zm4.977 1.894h-.675v-1.894a2.353 2.353 0 0 0-2.39-2.248 2.353 2.353 0 0 0-2.39 2.248v1.894h-.676A1.255 1.255 0 0 0 0-18.26l.45 4.66a1.251 1.251 0 0 0 1.258 1.242h5.228a1.25 1.25 0 0 0 1.258-1.228l.452-4.706a1.234 1.234 0 0 0-1.258-1.237",
        transform: "translate(425.72 565.666)",
        style: {
          stroke: "#f7fafc",
          strokeWidth: ".2px",
          fill: "#f8fafd"
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "c",
        d: "M430.578 551.557h-1.073l-.293-2.361a.809.809 0 0 1 .824-.791.8.8 0 0 1 .829.736Zm-.538-3.949a1.611 1.611 0 0 0-1.618 1.636l.336 2.754a.4.4 0 0 0 .4.351h1.773a.4.4 0 0 0 .4-.351l.336-2.81a1.6 1.6 0 0 0-1.623-1.58"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "c",
        d: "M427.968 546.649h-1.729l.469 6.2h2.776l-.759-6.387Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "c",
        d: "m428.63 546.389.165 2.01s-1.008.409.207 0 4.867-1.553 4.867-1.553l-1.157-.359-.764.089"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "c",
        d: "M433.655 546.752s.657 1.307-.168 4.877c-.4 1.368-.232 1.232-.232 1.232l-4.508-.145s.215-.722 2.028-.99a5.216 5.216 0 0 0 .465-2.46c0-.62-.175-.464-.542-.707s-1.7-.193-.923-.693a19.894 19.894 0 0 1 3.88-1.114Z"
      })]
    })]
  });
};
BlockedIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
};
const OfferSwitchCard = _ref => {
  var _periodMapper, _switchDetails$reason2;
  let {
    baseOfferId,
    toOfferId
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    data: allSwitchSettings,
    loading: isSwitchSettingsLoading
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectSwitchSettings);
  const switchDetails = allSwitchSettings[baseOfferId].available.find(switchData => switchData.toOfferId === toOfferId) || allSwitchSettings[baseOfferId].unavailable.find(switchData => switchData.toOfferId === toOfferId) || {};
  const period = (_periodMapper = _planHelper.periodMapper[switchDetails === null || switchDetails === void 0 ? void 0 : switchDetails.period]) === null || _periodMapper === void 0 ? void 0 : _periodMapper.chargedForEveryText;
  const currency = _planHelper.currencyFormat[switchDetails === null || switchDetails === void 0 ? void 0 : switchDetails.nextPaymentPriceCurrency];
  const getDescription = () => {
    var _switchDetails$reason;
    switch (switchDetails === null || switchDetails === void 0 || (_switchDetails$reason = switchDetails.reason) === null || _switchDetails$reason === void 0 ? void 0 : _switchDetails$reason.code) {
      case 'TO_OFFER_COUNTRY_NOT_ALLOWED':
        return t('offer-card.error.geo-restriction', "This plan is <strong>currently unavailable</strong> in your country or region");
      case 'ALREADY_HAS_ACCESS':
        return t('offer-card.error.already-have-access', 'It looks like you already have access to this offer');
      case 'TO_FREE_OFFER_NOT_ALLOWED':
        return t('offer-card.error.to-free-offer', 'Switching from a paid to a free offer is not possible');
      case 'SUBSCRIPTION_WITH_COUPON_NOT_ALLOWED':
        return t('offer-card.error.coupon-applied', "You can't change your subscription if a coupon was applied. To change plan, please cancel your current subscription and purchase a new one.");
      case 'SWITCH_IN_PROGRESS':
        return t('offer-card.error.switch-in-progress', 'Another switch is already in progress. Wait until the process finalization');
      case 'MISSING_PAYMENT_DETAILS':
        return t('offer-card.error.missing-payment-details', 'Your payment details are missing. Please add them to proceed with a subscription switch.');
      case 'MISSING_PAYMENT_FOR_PRORATION':
        return t('offer-card.error.missing-payment-for-proration', 'The upgrade will be available after the renewal date.');
      default:
        return '';
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferSwitchCardStyled.WrapperStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: !isSwitchSettingsLoading,
        width: 50,
        height: 50,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionIcon.default, {
          period: period || 'S'
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferSwitchCardStyled.InnerWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          showChildren: !isSwitchSettingsLoading,
          width: 200,
          margin: "0 10px 10px 10px",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCardStyled.TitleStyled, {
            children: t("offer-title-".concat(toOfferId), switchDetails.title)
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          showChildren: !isSwitchSettingsLoading,
          width: 300,
          margin: "0 10px 10px 10px"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCardStyled.PriceWrapperStyled, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          showChildren: !isSwitchSettingsLoading,
          width: 80,
          height: 30,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.default, {
            currency: currency,
            price: (0, _isPriceTemporaryModified.default)(toOfferId) && switchDetails.algorithm !== 'DEFERRED' ? switchDetails.price : switchDetails.nextPaymentPrice,
            period: switchDetails.period !== 'season' ? t("offer-price.period-".concat(switchDetails.period), switchDetails.period) : null
          })
        })
      })]
    }), (switchDetails === null || switchDetails === void 0 || (_switchDetails$reason2 = switchDetails.reason) === null || _switchDetails$reason2 === void 0 ? void 0 : _switchDetails$reason2.code) && getDescription() && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferSwitchCardStyled.SubBoxStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(BlockedIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCardStyled.SubBoxContentStyled, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCardStyled.BoxTextStyled, {
          dangerouslySetInnerHTML: {
            __html: getDescription()
          }
        })
      })]
    })]
  });
};
var _default = exports.default = OfferSwitchCard;